import React from 'react';
import ActionButton from '../actionButton';
var CreateNew = function (_a) {
    var height = _a.height, width = _a.width, handleCreateNew = _a.handleCreateNew;
    var onCreateNew = function () {
        if (handleCreateNew) {
            handleCreateNew();
        }
    };
    return (React.createElement(ActionButton, { variant: "primary", height: height || 40, width: width || 160, onClick: onCreateNew }, "Create New"));
};
export default CreateNew;
//# sourceMappingURL=index.js.map